<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Vendor/Supplier List  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-form-row>
        <b-col class="pl-1 pr-1" md="6">
            <b-form-group label-cols-md=1 label="Filter">
                  <b-form-row>
                    <b-col md="8">
                      <b-form-input v-model="tblData.vendor_name" @keyup.13.native="refresh()" placeholder="Vendor Name"></b-form-input>
                    </b-col>
                    <b-col md="4">
                      <b-form-input v-model="tblData.vendor_code" @keyup.13.native="refresh()" placeholder="Vendor Code"></b-form-input>
                    </b-col>
                  </b-form-row>                
            </b-form-group>
        </b-col>
        <b-col class="pl-1 pr-1" md="4">
          <b-input-group >
              <b-input-group-prepend><label style="text-align: left; width:80px;">Category</label></b-input-group-prepend>
              <b-form-input v-model="tblData.bussinesgroup" @keyup.13.native="refresh()" placeholder="Bussines Group"></b-form-input>
          </b-input-group>
          </b-col>
        <b-col class="pl-1" md="2">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
          </b-row>
        </b-col>
    </b-form-row>                      
        <b-table
          class="mb-0"
          ref="tblVendor"
          responsive
          striped hover 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(telepon)="data">
            <span v-if="(data.item.telepon)">P.{{data.item.telepon}}</span>&nbsp;
            <span v-if="(data.item.faximile)">F.{{data.item.faximile}}</span>
          </template>
          <template v-slot:cell(vendor_address1)="data">
            {{data.item.vendor_address1}} {{data.item.kota}} {{data.item.negara}}
          </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>

        </b-table>
        <b-row>
          <b-col cols="6">{{showingLabel}}</b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<script>
import vendor from "../../apis/bakerysupplier";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "vendor_code",
            label: "Vendor Code",
            thStyle: "width:130px",
            sortable: true
          },
          {
            key: "vendor_name",
            thStyle: "width:250px",
            label: "Vendor Name",
            sortable: true
          },
          {
            key: "bussinesgroup",
            thStyle: "width:250px",
            label: "Bussines Group/Category",
            sortable: true
          },
          {
            key: "telepon",
            label: "Phone/Fax",
            thStyle: "width:150px",
          },
          {
            key: "vendor_address1",
            label: "Address"
          },
          {
            key: "npwp",
            thStyle: "width:100px",
            label: "N P W P",
          },
          {
            key: "npwp_name",
            thStyle: "width:200px",
            label: "Nama WP",
            sortable: true
          },
          {
            key: "action",
            thStyle: "width:40px",
            label: "action",
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      model:{},
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`

    };
  },
  components :{Loading},
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, limit, total } = tblData;

      const val1 = (page - 1) * limit + 1;
      const val2 = page * limit < total ? page * limit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await vendor.list(this.tblData);
      this.lkuLoading = false;
      return list;  
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor_code = '';
        this.tblData.vendor_name =  '';
        this.tblData.bussinesgroup = '';
        this.tblData.contact =  '';
        this.refresh();
    },    
    add: function(data) {
          router.push({name :'bakery.supplierfrm'});
    },
    edit: function(data) {
        // router.push(`payment/${data.trbankkey}`);
        router.push({name :'bakery.supplierfrm', params: { vendor_id: data.vendor_id}});
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await vendor.remove(this.model);
      this.refresh();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await vendor.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    close(){
      router.push("home");
    },    

  }
};
</script>
